export const parseDateFormat = (pattern: string) => {
	// default pattern in case there are no cookies set (standalone and guest sb)
	let newPattern = pattern || 'dd.MM.yy HH:mm';
	// convert dd into DD (day of month long)
	const dayRegExPattern = /([^d]|^)dd([^d]|$)/g;
	newPattern = newPattern.replace(dayRegExPattern, '$1DD$2');
	// convert E into ddd || EEE indo ddd || EEEE into dddd (name of
	// day)
	if (newPattern.indexOf('EEEE') !== -1) {
		newPattern = newPattern.replace('EEEE', 'dddd');
	} else if (newPattern.indexOf('E') !== -1 || newPattern.indexOf('EEE') !== -1) {
		newPattern = newPattern.replace('EEE', 'ddd').replace('E', 'ddd');
	}
	// convert yyyy into YYYY (year long)
	newPattern = newPattern.replace('yyyy', 'YYYY');
	// convert yy into YY (year short)
	newPattern = newPattern.replace('yy', 'YY');
	// convert ssss into SSS (milliseconds)
	newPattern = newPattern.replace('ssss', 'SSS');
	// convert zzz to zz
	if (newPattern.indexOf('zzz') !== -1 || newPattern.indexOf('zzzz') !== -1) {
		newPattern = newPattern.replace('zzzz', 'zz').replace('zzz', 'zz');
	}

	return newPattern;
};
